export const getTruncatedText = (inputString, maxLength = 20) => {
  let newString = inputString ?? "";

  if (newString.length > maxLength) {
    newString = newString.slice(0, maxLength).concat("...");
  }

  return newString;
};
